export const environment = {
  production: true,
  apiEndPoint: 'https://api.shadowfax.in/',
  maptilerkey:'HO2SNqfS7QPAr6wsvZW1',
};
